// extracted by mini-css-extract-plugin
export default {"row":"FCXIh","teaser":"Yorcs","illustration":"S6gSD","image":"qwvIk","infos":"VREzf"};